













import cfg from '@/config';
import Vue from 'vue';

export default Vue.extend({
    components: {
        VueRecaptcha: () => import('vue-recaptcha'),
    },

    data() {
        return {
            recaptchaSiteKey: cfg.recaptchaSiteKey,
        };
    },

    mounted() {
        this.createRecaptcha();
    },

    beforeDestroy() {
        if (document.getElementById('recaptcha-script')) {
            document.getElementById('recaptcha-script').remove();
        }
    },

    methods: {
        createRecaptcha() {
            if (this.recaptchaSiteKey && !document.getElementById('recaptcha-script')) {
                const script = document.createElement('script');
                script.setAttribute('async', '');
                script.setAttribute('defer', '');
                script.id = 'recaptcha-script';
                script.src = 'https://www.google.com/recaptcha/api.js?onload=vueRecaptchaApiLoaded&render=explicit';
                document.getElementsByTagName('head')[0].appendChild(script);
            }
        },
        onVerify(r) {
            this.$emit('verify', r);
            // Auto reset for another try.
            this.reset();
        },
        execute() {
            if (!this.$refs.recaptcha) {
                throw new Error('Tried to execute recaptcha but it is not loaded.');
            }
            return this.$refs.recaptcha ? this.$refs.recaptcha.execute() : null;
        },
        reset() {
            return this.$refs.recaptcha ? this.$refs.recaptcha.reset() : null;
        },
    },
});
